<div class="main-layout">
  <header class="text-center w-full d-flex justify-content-center">
    <img src="assets/logo.svg" alt="Visera logo" class="subscription-logo main-logo" />
  </header>

  <main class="container">
    <router-outlet></router-outlet>
  </main>
</div>
